import { RouteRecordRaw } from 'vue-router';

export const wholesaleRoutes: RouteRecordRaw[] = [
  {
    name: 'wholesale',
    path: '/wholesale/:keywords',
    component: () => import('./pages/wholesale-browser.vue'),
  },
];
